/** Model backtest quality (0–100). Distinct from forecast uncertainty. */

export const MODEL_QUALITY_LABEL = 'Qualité modèle (6 mois)';
export const MODEL_QUALITY_TOOLTIP = 'Score sur 6 mois d\'historique (100 − WAPE)';
export const MODEL_QUALITY_AVERAGE_LABEL = 'Qualité modèle moyenne (6 mois)';

export type ModelQualityStatus = 'computed' | 'not_computable' | 'insufficient_data';

export interface ModelQualitySource {
  model_quality?: number | null;
  confidence?: number | null;
}

export interface ModelQualityPoint {
  confidence?: number | null;
}

/** Resolve quality from API payload (prefers model_quality, falls back to confidence). */
export function resolvePointModelQuality(item: ModelQualitySource): number | null {
  if (typeof item.model_quality === 'number') {
    return item.model_quality;
  }
  if (typeof item.confidence === 'number') {
    return item.confidence;
  }
  return null;
}

/** Average quality over months with a computable score; null when none. */
export function calculateAverageModelQuality(
  modelData: ModelQualityPoint[] | null | undefined,
): number | null {
  if (!modelData?.length) {
    return null;
  }

  const values = modelData
    .map((point) => point.confidence)
    .filter((value): value is number => typeof value === 'number');

  if (!values.length) {
    return null;
  }

  return values.reduce((sum, value) => sum + value, 0) / values.length;
}

export function formatModelQuality(value: number | null | undefined): string {
  if (typeof value !== 'number') {
    return 'N/A';
  }
  return `${value.toFixed(1)}%`;
}

export function hasComputableModelQuality(value: number | null | undefined): value is number {
  return typeof value === 'number';
}
